import React, { useState, useContext } from "react";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
//Icons
import { MdDelete } from "react-icons/md";
import { ImKey } from "react-icons/im";
import { TbEdit } from "react-icons/tb";

//Srcs
import "../../Style/actionstyle.scss";
import Delete from "../Include/Delete";
import UpdateSuppiler from "./UpdateSupplier";
import { DELETE_SUPPLIER } from "../../Schema/Supplier";
import { AuthContext } from "../../Context/AuthContext";
import { useMutation } from "@apollo/client";

export default function SupplierAction({ editData, setRefetch }) {
  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  //Modal reset
  const [openReset, setOpenReset] = useState(false);
  const handleOpenReset = () => setOpenReset(true);
  const handleCloseReset = () => setOpenReset(false);
  const [loading, setLoading] = useState(false);
  const { setAlert } = useContext(AuthContext);

  const [deleteSupplier] = useMutation(DELETE_SUPPLIER, {
    onCompleted: ({ deleteSupplier }) => {
      // console.log("deleteSupplier::", deleteSupplier);
      setLoading(false);
      if (deleteSupplier?.status === true) {
        setAlert(true, "success", deleteSupplier?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", deleteSupplier?.message);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteSupplier({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title="កែប្រែ" placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <TbEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        <Tooltip title="លុប" placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      <UpdateSuppiler
        open={openEdit}
        handleClose={handleCloseEdit}
        editData={editData}
        setRefetch={setRefetch}
      />

      <Delete
        open={openDel}
        handleClose={handleCloseDel}
        title={"អ្នកផ្គត់ផ្គង"}
        loading={loading}
        handleDelete={handleDelete}
      />
    </div>
  );
}
